import { useEffect, useState } from 'react';
import { accounts } from './BrandStyles';
import { usingAIGBranding } from '../../components/BrandingWhiteLabel/WhiteLabelProvider';
import { getTranslation } from '../../components/Global/helpers';
import { setBrandContent } from './BrandContent';

export const useWhiteLabel = (account) => {
    const [brandingComplete, setBrandingComplete] = useState(false);
    const [pageLoader, setPageLoader] = useState(true);

    useEffect(() => {
        if (usingAIGBranding.includes(account) || account === 'grayscale') {
            setBrandingComplete(true);
            setPageLoader(false);
            return;
        }

        const fetchData = async () => {
            const brandStylePath = `Whitelabel/Vendor/BrandValues/${account?.replace(/\s+/g, '')?.toLowerCase()}_style.json`;
            const brandContentPath = `Whitelabel/Vendor/BrandContent/${account?.replace(/\s+/g, '')?.toLowerCase()}_content.json`;
            const coverageContentPath = `Whitelabel/Vendor/BrandContent/coveragetype_content.json`;
            const whatscoveredContentPath = `Whitelabel/Vendor/BrandContent/whatscovered_content.json`;
            const advantageBenefitsContentPath = `Whitelabel/Vendor/BrandContent/advantageBenefits_content.json`;
            const whatscoveredSliderPath = `Whitelabel/Vendor/BrandContent/whatscovered_slider_content.json`;
            const root = document.getElementsByTagName('html')[0];

            await getTranslation(brandStylePath)
                .then((response) => response?.json())
                .then((data) => {
                    // deconstruct all values from creative brandvalues
                    const {
                        colors,
                        type,
                        h,
                        buttons,
                        input,
                        miscInput,
                        table,
                        tabs,
                        sideNav,
                        mainNav,
                        scriptBox,
                        dashboard,
                        advantage,
                        images,
                        resourceTab
                    } = data;
                    // Primary Branding Values
                    if (colors) {
                        colors.colorsPrimaryBrand
                            && root.style.setProperty('--PrimaryBrandColor', colors.colorsPrimaryBrand);
                        colors.colorsSecondaryBrand
                            && root.style.setProperty('--SecondaryBrandColor', colors.colorsSecondaryBrand);
                        colors.colorsPrimaryText
                            && root.style.setProperty('--PrimaryTextColor', colors.colorsPrimaryText);
                        colors.colorsIconColor && root.style.setProperty('--IconColor', colors.colorsIconColor);
                        colors.colorsLinkColor && root.style.setProperty('--LinkColor', colors.colorsLinkColor);
                        colors.colorsLinkColor && root.style.setProperty('--BtnLink__Text', colors.colorsLinkColor);
                        colors.colorsError && root.style.setProperty('--ErrorColor', colors.colorsError);
                        colors.colorsFocus && root.style.setProperty('--FocusColor', colors.colorsFocus);
                        colors.colorsHeadingColor
                            && root.style.setProperty('--Heading__Color', colors.colorsHeadingColor);
                        colors.colorsNeutral1 && root.style.setProperty('--Color__Neutral1', colors.colorsNeutral1);
                        colors.colorsNeutral2 && root.style.setProperty('--Color__Neutral2', colors.colorsNeutral2);
                        colors.colorsNeutral3 && root.style.setProperty('--Color__Neutral3', colors.colorsNeutral3);
                        colors.colorsNeutral4 && root.style.setProperty('--Color__Neutral4', colors.colorsNeutral4);
                        colors.colorsNeutral5 && root.style.setProperty('--Color__Neutral5', colors.colorsNeutral5);
                    }
                    //Advantage
                    if (advantage) {
                        advantage.advantageAccent
                            && root.style.setProperty('--AdvantageAccentColor', advantage.advantageAccent);
                        advantage.advantageText
                            && root.style.setProperty('--Advantage__TextColor', advantage.advantageText);
                    }
                    // Typography
                    if (type) {
                        type.textFont && root.style.setProperty('--TextFont', type.textFont);
                        type.fontSize && root.style.setProperty('--FontSize', type.fontSize);
                        type.lineHeight && root.style.setProperty('--LineHeight', type.lineHeight);
                        type.letterSpacing && root.style.setProperty('--LetterSpacing', type.letterSpacing);
                    }
                    // Headings
                    if (h) {
                        h.headingFont && root.style.setProperty('--Heading__Font', h.headingFont);
                        h.headingFontWeight && root.style.setProperty('--Heading__FontWeight', h.headingFontWeight);
                        // h.headingColor && root.style.setProperty("--Heading__Color", h.headingColor);
                        h.h1Size && root.style.setProperty('--H1__Size', h.h1Size);
                        h.h1LineHeight && root.style.setProperty('--H1__LineHeight', h.h1LineHeight);
                        h.h2Size && root.style.setProperty('--H2__Size', h.h2Size);
                        h.h2LineHeight && root.style.setProperty('--H2__LineHeight', h.h2LineHeight);
                        h.h3Size && root.style.setProperty('--H3__Size', h.h3Size);
                        h.h3LineHeight && root.style.setProperty('--H3__LineHeight', h.h3LineHeight);
                        h.h4Size && root.style.setProperty('--H4__Size', h.h4Size);
                        h.h4LineHeight && root.style.setProperty('--H4__LineHeight', h.h4LineHeight);
                        h.h5Size && root.style.setProperty('--H5__Size', h.h5Size);
                        h.h5LineHeight && root.style.setProperty('--H5__LineHeight', h.h5LineHeight);
                        h.h5Weight && root.style.setProperty('--H5__Weight', h.h5Weight);
                        h.h6Size && root.style.setProperty('--H6__Size', h.h6Size);
                        h.h6LineHeight && root.style.setProperty('--H6__LineHeight', h.h6LineHeight);
                        h.h6Weight && root.style.setProperty('--H6__Weight', h.h6Weight);
                    }
                    // Buttons
                    if (buttons) {
                        buttons.btnBorderRadius
                            && root.style.setProperty('--Btn__BorderRadius', buttons.btnBorderRadius);
                        buttons.btnPadding && root.style.setProperty('--Btn__Padding', buttons.btnPadding);
                        buttons.btnAndInputFontSize
                            && root.style.setProperty('--BtnAndInput__FontSize', buttons.btnAndInputFontSize);
                        buttons.btnLineHeight && root.style.setProperty('--Btn__LineHeight', buttons.btnLineHeight);
                        buttons.btnPrimaryBg && root.style.setProperty('--BtnPrimary__Bg', buttons.btnPrimaryBg);
                        buttons.btnPrimaryText && root.style.setProperty('--BtnPrimary__Text', buttons.btnPrimaryText);
                        buttons.btnPrimaryBorder
                            && root.style.setProperty('--BtnPrimary__Border', buttons.btnPrimaryBorder);
                        buttons.btnPrimaryHoverBg
                            && root.style.setProperty('--BtnPrimary__HoverBg', buttons.btnPrimaryHoverBg);
                        buttons.btnPrimaryHoverBorder
                            && root.style.setProperty('--BtnPrimary__HoverBorder', buttons.btnPrimaryHoverBorder);
                        buttons.btnPrimaryHoverText
                            && root.style.setProperty('--BtnPrimary__HoverText', buttons.btnPrimaryHoverText);
                        buttons.btnSecondaryBg && root.style.setProperty('--BtnSecondary__Bg', buttons.btnSecondaryBg);
                        buttons.btnSecondaryText
                            && root.style.setProperty('--BtnSecondary__Text', buttons.btnSecondaryText);
                        buttons.btnSecondaryBorder
                            && root.style.setProperty('--BtnSecondary__Border', buttons.btnSecondaryBorder);
                        buttons.btnSecondaryHoverBg
                            && root.style.setProperty('--BtnSecondary__HoverBg', buttons.btnSecondaryHoverBg);
                        buttons.btnSecondaryHoverBorder
                            && root.style.setProperty('--BtnSecondary__HoverBorder', buttons.btnSecondaryHoverBorder);
                        buttons.btnSecondaryHoverText
                            && root.style.setProperty('--BtnSecondary__HoverText', buttons.btnSecondaryHoverText);
                        // buttons.btnLinkText && root.style.setProperty("--BtnLink__Text", buttons.btnLinkText);
                        buttons.btnDisabledBg && root.style.setProperty('--BtnDisabled__Bg', buttons.btnDisabledBg);
                        buttons.btnDisabledText
                            && root.style.setProperty('--BtnDisabled__Text', buttons.btnDisabledText);
                        buttons.btnDisabledBorder
                            && root.style.setProperty('--BtnDisabled__Border', buttons.btnDisabledBorder);
                    }
                    // Input Values
                    if (input) {
                        input.inputLabelColor && root.style.setProperty('--Input__LabelColor', input.inputLabelColor);
                        input.inputLabelLineHeight
                            && root.style.setProperty(
                                '--Input__LabelLineHeinputLabelLineHeight',
                                input.inputLabelLineHeight
                            );
                        input.inputLabelMarginBottom
                            && root.style.setProperty('--Input__LabelMarginBottom', input.inputLabelMarginBottom);
                        input.inputLabelWeight
                            && root.style.setProperty('--Input__LabelWeightinputLabelWeight', input.inputLabelWeight);
                        input.inputPlaceholder
                            && root.style.setProperty('--Input__Placeholder', input.inputPlaceholder);
                        input.inputRequiredAsterisk
                            && root.style.setProperty('--Input__RequiredAsterisk', input.inputRequiredAsterisk);
                        input.inputLineHeight
                            && root.style.setProperty('--Input__LininputLineHeight', input.inputLineHeight);
                        input.inputBorderRadius
                            && root.style.setProperty('--Input__BorderRadius', input.inputBorderRadius);
                        input.inputBorder && root.style.setProperty('--Input__Border', input.inputBorder);
                        input.inputEntered && root.style.setProperty('--Input__Entered', input.inputEntered);
                        input.inputFocusBorder
                            && root.style.setProperty('--InputFocus__Border', input.inputFocusBorder);
                        input.inputErrorColor && root.style.setProperty('--InputError__Color', input.inputErrorColor);
                        input.inputErrorBg && root.style.setProperty('--InputError__Bg', input.inputErrorBg);
                        input.inputDisabledBg && root.style.setProperty('--InputDisabled__Bg', input.inputDisabledBg);
                        input.inputDisabledText
                            && root.style.setProperty('--InputDisabled__Text', input.inputDisabledText);
                        input.inputDisabledBorder
                            && root.style.setProperty('--InputDisabled__Border', input.inputDisabledBorder);
                        input.inputIcon && root.style.setProperty('--Input__Icon', input.inputIcon);
                        input.inputIconHeight && root.style.setProperty('--Input__IconHeight', input.inputIconHeight);
                        input.inputIconWidth && root.style.setProperty('--Input__IconWidth', input.inputIconWidth);
                    }
                    // Checkboxes
                    if (miscInput) {
                        miscInput.toggleColor && root.style.setProperty('--InputToggle__Color', miscInput.toggleColor);
                        miscInput.checkboxBorder
                            && root.style.setProperty('--Checkbox__Border', miscInput.checkboxBorder);
                        miscInput.checkboxHeight
                            && root.style.setProperty('--Checkbox__Height', miscInput.checkboxHeight);
                        miscInput.checkboxWidth && root.style.setProperty('--Checkbox__Width', miscInput.checkboxWidth);
                        miscInput.checkboxCheckedBg
                            && root.style.setProperty('--Checkbox__CheckedBg', miscInput.checkboxCheckedBg);
                        miscInput.checkboxCheckColor
                            && root.style.setProperty('--Checkbox__CheckColor', miscInput.checkboxCheckColor);
                        // Drobdowns
                        miscInput.dropdownArrowColor
                            && root.style.setProperty('--Drop__ArrowColor', miscInput.dropdownArrowColor);
                        miscInput.dropdownOptionHoverBg
                            && root.style.setProperty('--DropOption__HoverBg', miscInput.dropdownOptionHoverBg);
                        // Radios
                        miscInput.radioButtonBorder
                            && root.style.setProperty('--RadioButton__Border', miscInput.radioButtonBorder);
                        miscInput.radioButtonBg && root.style.setProperty('--RadioButton__Bg', miscInput.radioButtonBg);
                        miscInput.radioButtonCheckedBorder
                            && root.style.setProperty(
                                '--RadioButton__CheckedBorder',
                                miscInput.radioButtonCheckedBorder
                            );
                        miscInput.radioButtonCheckedBg
                            && root.style.setProperty('--RadioButton__CheckedBg', miscInput.radioButtonCheckedBg);
                        // Radios with Background
                        miscInput.radioWithBgBorder
                            && root.style.setProperty('--RadioWithBg__Border', miscInput.radioWithBgBorder);
                        miscInput.radioWithBgBg && root.style.setProperty('--RadioWithBg__Bg', miscInput.radioWithBgBg);
                        miscInput.radioWithBgText
                            && root.style.setProperty('--RadioWithBg__Text', miscInput.radioWithBgText);
                        miscInput.radioWithBgCheckedBorder
                            && root.style.setProperty(
                                '--RadioWithBg__CheckedBorder',
                                miscInput.radioWithBgCheckedBorder
                            );
                        miscInput.radioWithBgCheckedBg
                            && root.style.setProperty('--RadioWithBg__CheckedBg', miscInput.radioWithBgCheckedBg);
                        miscInput.radioWithBgCheckedText
                            && root.style.setProperty('--RadioWithBg__CheckedText', miscInput.radioWithBgCheckedText);
                    }
                    //Resources Tab
                    if (resourceTab) {
                        resourceTab.activeSideTabBg
                            && root.style.setProperty('--ResourceSideTab__ActiveBg', resourceTab.activeSideTabBg);
                        resourceTab.activeSideTabBorder
                            && root.style.setProperty(
                                '--ResourceSideTab__ActiveBorder',
                                resourceTab.activeSideTabBorder
                            );
                    }
                    // Table
                    if (table) {
                        table.rowBg && root.style.setProperty('--Table__RowBg', table.rowBg);
                    }
                    if (tabs) {
                        tabs.activeTabColor && root.style.setProperty('--ActiveTab', tabs.activeTabColor);
                        tabs.activeTabText && root.style.setProperty('--ActiveTab__Text', tabs.activeTabText);
                    }
                    // Side Navigation Bar
                    if (sideNav) {
                        sideNav.sideNavBg && root.style.setProperty('--SideNav__Bg', sideNav.sideNavBg);
                        sideNav.sideNavTextColor
                            && root.style.setProperty('--SideNav__TextColor', sideNav.sideNavTextColor);
                        sideNav.sideNavActiveSideLine
                            && root.style.setProperty('--SideNav__ActiveSideLine', sideNav.sideNavActiveSideLine);
                        sideNav.sideNavActiveBg
                            && root.style.setProperty('--SideNav__ActiveBg', sideNav.sideNavActiveBg);
                        sideNav.sideNavActiveText
                            && root.style.setProperty('--SideNav__ActiveText', sideNav.sideNavActiveText);
                    }
                    // Main Tab Navigation Bar
                    if (mainNav) {
                        mainNav.mainNavIcon && root.style.setProperty('--MainNav__Icon', mainNav.mainNavIcon);
                        mainNav.mainNavColor && root.style.setProperty('--MainNav__ActiveColor', mainNav.mainNavColor);
                        mainNav.mainNavTextColor
                            && root.style.setProperty('--MainNav__TextColor', mainNav.mainNavTextColor);
                    }
                    // Script Box
                    if (scriptBox) {
                        scriptBox.scriptBoxBorder
                            && root.style.setProperty('--ScriptBox__Border', scriptBox.scriptBoxBorder);
                        scriptBox.scriptBoxBg && root.style.setProperty('--ScriptBox__Bg', scriptBox.scriptBoxBg);
                    }
                    //Dashboard
                    // Main Tab Navigation Bar
                    if (dashboard) {
                        dashboard.accent1 && root.style.setProperty('--Color__Accent1', dashboard.accent1);
                        dashboard.accent2 && root.style.setProperty('--Color__Accent2', dashboard.accent2);
                        dashboard.accent3 && root.style.setProperty('--Color__Accent3', dashboard.accent3);
                        dashboard.accent4 && root.style.setProperty('--Color__Accent4', dashboard.accent4);
                        dashboard.circleBg && root.style.setProperty('--CircleBg', dashboard.circleBg);
                        dashboard.circleIcon && root.style.setProperty('--CircleIcon', dashboard.circleIcon);
                        dashboard.circleBorder && root.style.setProperty('--CircleBorder', dashboard.circleBorder);
                    }
                    // Images
                    if (images) {
                        images.illustrationsPrimary
                            && root.style.setProperty('--IllustrationsPrimary', images.illustrationsPrimary);
                        images.illustrationsAcent1
                            && root.style.setProperty('--IllustrationsAcent1', images.illustrationsAcent1);
                        images.illustrationsAcent2
                            && root.style.setProperty('--IllustrationsAcent2', images.illustrationsAcent2);
                        images.twoTonePrimary && root.style.setProperty('--TwoTonePrimary', images.twoTonePrimary);
                        images.twoToneSecondary
                            && root.style.setProperty('--TwoToneSecondary', images.twoToneSecondary);
                    }

                    setBrandingComplete(true);
                });

            const accountContent = await getTranslation(brandContentPath).then((response) => response?.json());
            const coverageContent = await getTranslation(coverageContentPath).then((response) => response?.json());
            const whatscoveredContent = await getTranslation(whatscoveredContentPath).then((response) =>
                response?.json()
            );
            const advantageBenefitsContent = await getTranslation(advantageBenefitsContentPath).then((response) =>
                response?.json()
            );
            const whatscoveredSliderContent = getTranslation(whatscoveredSliderPath).then((response) =>
                response?.json()
            );

            Promise.all([
                accountContent,
                coverageContent,
                whatscoveredContent,
                advantageBenefitsContent,
                whatscoveredSliderContent
            ]).then((data) => {
                setBrandContent({
                    account: data?.[0],
                    coveragetype: data?.[1],
                    whatscovered: data?.[2],
                    advantageBenefits: data?.[3],
                    whatscoveredSlider: data?.[4]
                });
                setPageLoader(false);
            });
        };
        account && fetchData();
    }, [account]);

    return { brandingComplete, pageLoader };
};
